<template>
	<div class="re-system">
        <div class="resystem-header">
            <el-page-header show-back-icon :title="$t('listPage.text.reInstallSystem')" @back="cancelReInstall()" class="relative">
            </el-page-header>
        </div>
        <div class="ml40">
            <!--主机当前信息-->
            <h3 class="title-position">
                {{ $t('listPage.text.hostNowInformation')}}
            </h3>
            <el-table :data="tableData" class="table-size">
                <el-table-column :label="$t('privateNetInstance.instanceID')"
                    prop="instanceId" min-width="150px">
                </el-table-column>
                <el-table-column :label="$t('privateNetInstance.instanceName')"
                    prop="name" min-width="150px">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.name"
                            placement="bottom">
                        <span>
                            {{scope.row.name}}
                        </span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('detail.text.operateSystem')"
                    prop="osName">
                </el-table-column>
                <el-table-column :label="$t('privateNetInstance.sysDisk')"
                    prop="system" min-width="150px">
                </el-table-column>
                <el-table-column :label="$t('privateNetInstance.chargeMethod')"
                    prop="chargeType">
                </el-table-column>
                <el-table-column :label="$t('privateNetInstance.expireTime')"
                    prop="expire" v-if="chargeModeType==='prepaid_by_duration'"
                    min-width="150">
                </el-table-column>
            </el-table>
            <el-form :model="form" ref="form"
                :rules="rules"
                label-width="150px" class="form-position">
                <!--镜像-->
                <h3 class="title-position">
                    {{ $t('create.text.mirror')}}
                </h3>
                <!-- 镜像类型 -->
                <el-form-item :label="$t('privateNetInstance.mirrorType') | withColon" id="osTypeId">
                    <el-radio-group v-model="selectedImageType">
                        <el-radio-button
                            v-for="(item,key,index) in imageTypes" :key="index"
                            :label="key">{{item.sourceName}}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <!-- 操作系统 -->
                <el-form-item :label="$t('privateNetInstance.operateSystem') | withColon">
                    <el-radio-group v-model="form.operate"
                        @change="systemChange">
                        <el-radio-button v-for="(os, index) in form.oss"
                            :key="index"
                            :label="os">
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <!-- 系统版本 -->
                <el-form-item :label="$t('privateNetInstance.systemVersion') | withColon"
                    prop="osTypeId">
                    <el-select v-model="form.osTypeId" size="small" @change="getSelectOsId">
                        <el-option v-for="(select, index) in form.osTypes[form.operate]"
                            :key="index"
                            :label="select.osName"
                            :value="select.osTypeId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--存储-->
                <h3 class="title-position">
                    {{ $t('create.text.storage')}}
                </h3>
                <el-form-item :label="$t('create.text.sysDiskCapacity') | withColon">
                    <span class="c333">{{sysDiskCapacity}}</span>
                    <span class="el-form-item-help">{{$t('create.text.sysDiskCapacityUnitTip')}}</span>
                </el-form-item>
                <el-form-item id="systemPartition"
                    :label="$t('retailInstance.text.systemDataPartitions') | withColon">
                    <template v-if="systemType === 'windows'">
                        <span>{{$t('retailInstance.text.emptyPartition')}}</span>
                    </template>
                    <template v-else>
                        <el-radio-group v-model="selectedPartitionMode">
                            <el-radio v-for="(item,index) in systemDiskPartitionModes" :key="index"
                                :label="item.value">
                                {{item.label}}
                            </el-radio>
                        </el-radio-group>
                        <el-tooltip class="ml10" effect="dark" placement="right"
                            content="Right Top">
                            <div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.systemPartition')}}
                            </div>
                            <a><i class="jc-icon-question"></i></a>
                        </el-tooltip>
                        <section
                            class="defaultPartition"
                            v-if="selectedPartitionMode === 'default'"
                            v-html="defaultSystemDataPartitions">
                        </section>
                        <custom-partition
                            ref="systemPartition"
                            :visible="selectedPartitionMode === 'custom'"
                            :region="region"
                            diskType="system"
                            :partitionInfos="systemDataPartitions"
                            :otherPartitionInfos="dataDiskPartitions"
                            :isCentOS66="isCentOS66"
                            :totalDiskSize="systemDiskSize">
                        </custom-partition>
                    </template>
                </el-form-item>
                <el-form-item
                    v-if="rowInfo.dataRaidTypeId"
                    :label="$t('privateNetInstance.dataDisk') | withColon">
                    <el-checkbox v-model="form.checked">
                        {{ $t('privateNetInstance.formatDataDisk') }}
                    </el-checkbox>
                    <br/>
                    <span v-if="form.checked" class="ff0">
                        {{ $t('listPage.speechCraft.dataFormattedRedWarning') }}
                    </span>
                </el-form-item>
                <el-form-item :label="$t('privateNetInstance.dataDisk') | withColon" v-if="form.checked">
                    <card-group :showData="getDataDisks"
                        :chooseTypeId="form.hasRowInfoDataRaidTypeId ? rowInfo.dataRaidTypeId : form.dataRaidTypeId"
                        @getType="getSelectType">
                    </card-group>
                </el-form-item>
                <el-form-item
                    v-if="form.checked"
                    :label="$t('create.text.dataDiskCapacity') | withColon">
                    <span class="c333">{{dataDiskCapacity}}</span>
                    <span class="el-form-item-help">{{$t('create.text.sysDiskCapacityUnitTip')}}</span>
                </el-form-item>

                <el-form-item
                    id="dataPartition"
                    :label="$t('retailInstance.text.dataDiskPartition') | withColon"
                    v-if="form.checked">
                    <template v-if="systemType === 'windows'">
                        <span>{{$t('retailInstance.text.emptyPartition')}}</span>
                    </template>
                    <template v-else>
                        <el-radio-group v-model="selectedDataDiskPartitionMode">
                            <el-radio v-for="(item,index) in dataDiskPartitionModes" :key="index"
                                :label="item.value">
                                {{item.label}}
                            </el-radio>
                        </el-radio-group>
                        <section
                            class="defaultPartition"
                            v-if="selectedDataDiskPartitionMode === 'default'"
                            v-html="defaultDataDiskPartitions">
                        </section>
                        <custom-partition
                            ref="dataPartition"
                            :visible="selectedDataDiskPartitionMode === 'custom'"
                            :region="region"
                            diskType="data"
                            :partitionInfos="dataDiskPartitions"
                            :otherPartitionInfos="systemDataPartitions"
                            :isCentOS66="isCentOS66"
                            :totalDiskSize="dataDiskSize">
                        </custom-partition>
                    </template>
                </el-form-item>
                 <!--网络信息-->
                <h3 class="title-position">
                    {{ $t('detail.text.netInfo')}}
                </h3>
                <el-form-item :label="$t('privateNetInstance.changeNet') | withColon">
					<el-tooltip class="item" :content="renetworkDisabledTip" :disabled="!Object.keys(this.rowInfo).length||!renetworkDisabled">
						<el-switch
							v-model="changeNetValue"
							:disabled="renetworkDisabled">
						</el-switch>
					</el-tooltip>
					<el-tooltip class="ml10" effect="dark" placement="right"
                            content="Right Top">
                            <div slot="content" class="my-os-disk-tip" v-html= "$t('privateNetInstance.changeNetworkTips')">
                            </div>
                            <a><i class="jc-icon-question"></i></a>
                        </el-tooltip>
                </el-form-item>
				<div v-if="changeNetValue" class="network">
					<!--网络接口数量-->
					<el-form-item :label="$t('create.text.networkQuantity') | withColon">
						<el-radio-button>
							{{ this.rowInfo.interfaceMode ==='bond'?$t('create.text.singleInternetAccess'):$t('create.text.doubleInternetAccess')}}
						</el-radio-button>
					</el-form-item>
					<!--网络接口名称-->
					<el-form-item :label="$t('create.text.networkName') | withColon" v-if="rowInfo.interfaceMode ==='bond'">
						<el-radio-button>{{$t('create.text.singleInternetAccessChiefName')}}
						</el-radio-button>
					</el-form-item>
					<el-form-item :label="$t('create.text.networkName') | withColon" v-else>
						<el-radio-group v-model="networkName"  class="network-name">
							<el-radio-button v-for="(item,index) in networkNameGroup"
								:key="index"
								:label="item.value">{{item.label}}
							</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<!-- 当前网口信息 -->
					<el-form-item :label="$t('privateNetInstance.currentNetworkMessage') | withColon" class="mb0">
					</el-form-item>
					<el-table :data="tableNetData" class="net-table-size">
						<el-table-column
							prop="instanceId"
							:label="$t('listPage.text.exampleID')"
							width="250px">
						</el-table-column>
						<el-table-column
							prop="instanceName"
							:label="$t('listPage.text.exampleName')"
							min-width="100px">
						</el-table-column>
						<el-table-column
							prop="az"
							:label="$t('list.region')"
							width="80px">
						</el-table-column>
						<el-table-column
							v-if="networkName==='eth0'"
							prop="privateNetwork"
							key="privateNetwork"
							:label="$t('subnet.text.privateNetwork')">
						</el-table-column>
						<el-table-column
							v-if="networkName==='eth0'"
							prop="subnet"
							key="subnet"
							:label="$t('subnet.text.subnet')">
						</el-table-column>
						<el-table-column
							v-if="networkName==='eth0'"
							key="intranetIp"
							:label="$t('detail.text.intranetIp')"
							min-width="100px">
							<p v-if="rowInfo.privateIp" >{{rowInfo.privateIp + $t('privateNetInstance.private') }}</p>
							<p v-else>{{ '--' + $t('privateNetInstance.private') }}</p>
							<p v-if="rowInfo.ipv6Address" >{{ rowInfo.ipv6Address + $t('privateNetInstance.ipv6Address') }}</p>
							<p v-else>{{ '--' + $t('privateNetInstance.ipv6Address') }}</p>
						</el-table-column>
						<el-table-column
							v-if="networkName==='eth1'"
							prop="extensionPrivateNetwork"
							key="extensionPrivateNetwork"
							:label="$t('subnet.text.privateNetwork')">
						</el-table-column>
						<el-table-column
							v-if="networkName==='eth1'"
							prop="extensionSubnet"
							key="extensionSubnet"
							:label="$t('subnet.text.subnet')">
						</el-table-column>
						<el-table-column
							v-if="networkName==='eth1'"
							prop="extensionIntranetIp"
							:label="$t('detail.text.intranetIp')"
							min-width="100px">
							<p v-if="rowInfo.extensionPrivateIp" >{{rowInfo.extensionPrivateIp + $t('privateNetInstance.private') }}</p>
							<p v-else>{{ '--' + $t('privateNetInstance.private') }}</p>
							<p v-if="rowInfo.extensionIpv6Address" >{{ rowInfo.extensionIpv6Address + $t('privateNetInstance.ipv6Address') }}</p>
							<p v-else>{{ '--' + $t('privateNetInstance.ipv6Address') }}</p>
						</el-table-column>
					</el-table>
					<el-form-item :label="$t('privateNetInstance.targetNetworkMessage') | withColon" >
                	</el-form-item>
					<div>
                    	<el-form
							ref="networkInfo"
							:rules="networkInfoRules"
							:model="netInfo"
							class="net-form"
							label-width="130px">
							<!-- 私有网络 -->
							<el-form-item :label="$t('privateNetInstance.targetPrivateNet')| withColon"
								class="net-select" prop="selectVpcId">
								<el-select v-model="netInfo.selectVpcId" class="select-vpc"
									@change="(id)=>vpcChange(id,'netInfo')"
									@visible-change="(isVisible)=>getRealTimeVpc(isVisible,'netInfo')"
									:placeholder="$t('privateNetInstance.chooseTargetVPC')"
									:disabled="vpcNotChange">
									<el-option v-for="(vpc, index) in vpcShowList"
										:key="index"
										:label="vpc.showName"
										:value="vpc.vpcId">
									</el-option>
								</el-select>
								<span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcCidr">{{$t('privateNetInstance.privateNetCidr',[netInfo.selectVpcCidr])}}</span>
								<span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcIpv6Cidr">{{$t('privateNetInstance.privateNetIpv6Cidr',[netInfo.selectVpcIpv6Cidr])}}</span>
							</el-form-item>
							<!-- 子网 -->
							<el-form-item :label="$t('privateNetInstance.targetSubnet') | withColon"
								class="net-select"
								prop="selectSubnetId">
								<el-select v-model="netInfo.selectSubnetId"
									class="select-vpc"
									:disabled="netInfo.subnetCount === 0||subnetNotChange"
									@change="(subnetId)=>subnetChange(subnetId,'netInfo')"
									@visible-change="(isVisible)=>getRealTimeSubnet(isVisible,'netInfo')"
									:placeholder="netInfo.subnetCount === 0 ? $t('privateNetInstance.notSubnet') : $t('privateNetInstance.chooseTargetSubnet')">
									<el-option v-for="(subnet, index) in subnetShowList"
										:key="index"
										:label="subnet.showName"
										:value="subnet.subnetId">
									</el-option>
								</el-select>
								<span slot="hint" v-if="netInfo.selectSubnetId && netInfo.selectSubnetCidr">{{$t('privateNetInstance.privateNetCidr',[netInfo.selectSubnetCidr])}}</span>
								<span slot="hint" v-if="netInfo.selectSubnetId && netInfo.selectSubnetIpv6Cidr">{{$t('privateNetInstance.privateNetIpv6Cidr',[netInfo.selectSubnetIpv6Cidr])}}</span>
							</el-form-item>
							<!-- 内网IP -->
							<el-form-item :label="$t('privateNetInstance.targetIntranetIp') | withColon">
								<div class="ip-input">
									<el-form-item>
										<el-select v-model="netInfo.isAuto" @change="clearInputIp('netInfo')">
											<el-option v-for="(operate, index) in netInfo.ipOperations"
												:key="index"
												:value="operate.value"
												:label="operate.label">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item prop="internetIp">
										<el-input
											:disabled="netInfo.isAuto === 1"
											class="inner-ip"
											@keyup.native="trimValue('internetIp')"
											v-model="netInfo.internetIp"
											:placeholder="netInfo.isAuto? $t('privateNetInstance.autoIpTip') : $t('privateNetInstance.notAutoIpTip')">
										</el-input>
										<p slot="hint" v-if="netInfo.isAuto">
											{{ $t('privateNetInstance.intranetIpTip', [netInfo.selectSubnetCidr]) }}
										</p>
										<p slot="hint" v-else>
											{{ $t('privateNetInstance.internetIpTipTwo1',[netInfo.selectSubnetCidr]) }}
										</p>
									</el-form-item>
								</div>
								<section>
									<p v-if="(!netInfo.selectVpcIpv6Cidr && !netInfo.selectSubnetIpv6Cidr)||!netInfo.selectVpcId">{{$t('create.text.openIpv6WithoutVpcTip1')}}</p>
									<p v-else-if="netInfo.selectVpcIpv6Cidr && !netInfo.selectSubnetIpv6Cidr">{{$t('create.text.openIpv6WithoutSubnetTip1')}}</p>
								</section>
							</el-form-item>
						</el-form>
					</div>
				</div>
                <!--基本信息-->
                <h3 class="title-position">
                    {{ $t('create.text.baseInfo')}}
                </h3>
                <el-form-item :label="$t('privateNetInstance.manager') | withColon">
                    <span>{{ 'root' }}</span>
                </el-form-item>
                <el-form-item :label="$t('privateNetInstance.hostname') | withColon"
                    prop="hostname">
                    <el-input :placeholder="$t('privateNetInstance.manageTip')"
                        v-model="form.hostname"></el-input>
                    <p slot="hint">{{ $t('create.help.mainServerNameRule') }}</p>
                </el-form-item>
                <div id="login">
                    <login-methods @getPassword="getPassword"
                    :region="region"
                    :operate="form.operate"
                    class="basic-resys-login"
                    ref="loginMethods"
                    pageType="privateNetInstance"></login-methods>
                </div>
            </el-form>
            <!--高级设置-->
            <h3 class="title-position">
                {{ $t('create.text.advanced')}}
            </h3>
            <custom-data :setCustomData.sync="form.advancedSetting"
                ref="advancedCustomData"
                :labelWidth="'150px'"
                :region="region"
                :selectedOS="form.operate"
                @getCustomData="getCustomData">
            </custom-data>
            <el-divider></el-divider>
            <div slot="footer" class="dialog-resystem-footer">
                <el-button @click="cancelReInstall">{{ $t('privateNetwork.cancel') }}</el-button>
                <el-button @click="sureReInstall('form')" type="primary" :disabled="changeNetDisabled" :loading="sureLoading">{{ $t('privateNetwork.sure') }}
                </el-button>
            </div>
        </div>
        <jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType"
			@success="onSuccess" @error="onError">
		</jcb-opt-protect>
	</div>
</template>

<script>

import cardGroup from '@/components/privateNetInstance/create/subs/CardGroup.vue';
import { CustomPartitionSupportConstant} from '@/common/Constants';
import { validatePassword } from '@/common/dataHelper';
import loginMethods from '@/components/common/loginMethods/LoginMethods';
import CustomData from '@/components/common/customData/CustomData';
import retailLoginMethods from '@/components/common/loginMethods/RetailLoginMethods';
import CustomPartition from '@/components/common/customPartition/customPartition';
import { deepCopy } from '@/common/tool';
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';

export default {
	name: 'ReSystem',
    mixins:[operationProtect],
	components: {
		cardGroup,
		loginMethods,
		retailLoginMethods,
		CustomData,
		CustomPartition
	},

	data() {
		const valPas = (rule, value, callback) => {
			if (!value) {
				callback(this.$t('privateNetwork.passwordNotNull'));
			} else if (!validatePassword(value)) {
				callback(this.$t('privateNetInstance.passwordTip'));
			} else {
				callback();
			}
		};
		const valRepas = (rule, value, callback) => {
			if (!value) {
				callback(this.$t('privateNetwork.repasswordNotNull'));
			} else if (value !== this.form.password) {
				callback(this.$t('privateNetwork.repasswordNotPass'));
			} else {
				callback();
			}
		};
		const validatehostName = (rule, value, callback) => {
			if (value === '') {
				callback();
			}
			const hostRule = /(^((?!(^-)|(-$)|(--+)|(^\\.)|(\\.$)|(\\.\\.+))[0-9A-Za-z-.]){2,64}$)|(^\s*$)/;
			if (!hostRule.test(value)) {
				callback(new Error(this.$t('create.help.mainServerNameRule')));
			} else {
				callback();
			}
		};
		const validateIpAddress = (rule, value, callback) => {
			const reg = /^(10|11|172|192)\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
			if (!this.netInfo.isAuto) {
				if (value === '') {
					callback(new Error(this.$t('create.placeholder.default')));
				}
				if (this.networkName ==='eth0' && value === this.rowInfo.privateIp){
					callback(new Error(this.$t('create.placeholder.ipAddressRepeat')));
				}
				if (this.networkName ==='eth1' && value === this.rowInfo.extensionPrivateIp) {
					callback(new Error(this.$t('create.placeholder.ipAddressRepeat')));
				}
				if (!reg.test(value)) {
					callback(new Error(this.$t('create.placeholder.ipAddressNotPass')));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		return {
			rules: {
				osTypeId: [
					{ required: true, message: this.$t('privateNetwork.osNotPass'), trigger: 'blur' },
				],
				password: [
					{ required: true, message: this.$t('privateNetwork.passwordNotNull'), trigger: 'blur' },
					{ validator: valPas, trigger: 'blur' }
				],
				repassword: [
					{ required: true, message: this.$t('privateNetwork.repasswordNotNull'), trigger: 'blur' },
					{ validator: valRepas, trigger: 'blur' }
				],
				selectKey: [
					{ required: true, trigger: 'change' }
				],
				hostname: [
					{
						validator: validatehostName,
						trigger: 'blur'
					}
				]
			},
			region:'',
			az:'',
			instanceId:'',
			deviceType:'',
			rowInfo:{},
			tableData: [],
			imageTypes: [],
			chargeModeType:'',
			selectedImageType:0,
			form: {
				oss: [],
				osTypes: {},
				operate: '',
				password: '',
				repassword: '',
				selectKey: '',
                sosKey: '',
				setKeyState: false,
				checked: false,
				hasRowInfoDataRaidTypeId: true,
				showData: [],
				chooseType: '',
				hostname: '',
				osTypeId: '',
				dataDisks: null,
				dataRaidTypeId: '',
                systemDiskPartitions:[],
				dataDiskPartitions:[],
				advancedSetting: false, // 高级设置开关(重装使用)
				userData: '' // 高级设置脚本内容，已base64过(重装使用)
			},
			isCentOS66:false,
			// 机型
			deviceType: '',
			deviceCustomPartitionSupport: true,
			// 系统盘总容量
			sysDiskCapacity: '',
			// 数据盘总容量
			dataDiskCapacity: '',
			systemDiskPartitionModes: [
				{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
				{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
			],
			selectedPartitionMode: 'default',
			defaultSystemDataPartitions: '',
			systemDataCustomPartitionVisible: false,
			systemDataPartitions: [],
			systemDiskSize: 0,
			dataDiskPartitionModes: [
				{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
				{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
			],
			selectedDataDiskPartitionMode: 'default',
			selectedDataRaid: {},
			defaultDataDiskPartitions: '',
			dataDiskPartitions: [],
			dataDiskSize: 0,
			//确定是否从详情跳入
			clickToDetail: false,
			//更换网络开关
			changeNetValue: false,
			//当前网口信息
			tableNetData:[],
			//双网口网络接口名称
			networkName:'eth0',
			//双网口网络接口
			networkNameGroup: [
				{id:1,label:this.$t('eip.text.chiefInternetAccessName'),value:'eth0'},
				{id:2,label:this.$t('eip.text.subInternetAccessName'),value:'eth1'},
			],
			//可用区表
			azs: [],
			realVpcId: '',
			buttonOnes: false,
			internetIpVaild: false,
			vpcNotChange:false,
			subnetNotChange:false,
			//更换网络信息规则
			networkInfoRules: {
				selectVpcId: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				],
				selectSubnetId: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				],
				internetIp: [
					{
						validator: validateIpAddress,
						trigger: 'blur'
					}
				],
			},
			//网络信息
            netInfo: {
				vpcCount: 0,
				subnetCount: 0,
				vpcList: [],
				vpcLists: [],
				subnetList: [],
				subnetLists: [],
				selectVpcId: '',
				selectVpcName: '',
				selectVpcCidr: '',
				selectVpcIpv6Cidr: '',
				selectSubnetId: '',
				selectSubnetName: '',
				selectSubnetCidr: '--',
				selectSubnetIpv6Cidr: '--',
				isAuto: 1,
				internetIp: '',
				ipOperations: [
					{
						value: 1,
						label: this.$t('privateNetInstance.autoIPv4')
					},
					{
						value: 0,
						label: this.$t('privateNetInstance.handwriteIPv4')
					}
				],
			},
            // 操作保护弹框是否显示
			operationProtectVisible: false,
      sureLoading: false,
		};
	},
	computed: {
        OperationConstant: () => OperationConstant,
		getDataDisks() {
			return this.form.dataDisks;
		},
		systemType() {
            console.log('this.form.operate', this.form.operate)
			// return this.form.operate === 'Windows' ? 'windows' : 'linux';
			return ['Windows', 'WindowsPC'].includes(this.form.operate) ? 'windows' : 'linux';
		},
		changeNetDisabled() {
			if(this.changeNetValue) {
				let disabled = this.netInfo.selectVpcId === ''||this.netInfo.selectSubnetId === ''||this.buttonOnes||(this.netInfo.isAuto !== 1 && (this.netInfo.internetIp === ''||this.internetIpVaild))
				return disabled
			}else {
				return false
			}
		},
		vpcShowList() {
			if (this.netInfo.vpcCount === 0) {
				this.netInfo.vpcList = [{
					vpcId: '',
					showName: this.$t('privateNetInstance.notVPC'),
				}];
			} else {
				this.netInfo.vpcList = this.netInfo.vpcLists.map(vpc => ({
					vpcId: vpc.vpcId,
					showName: `${vpc.name}(${vpc.vpcId})`,
					name: vpc.name,
					cidr: vpc.cidr,
					ipv6Cidr: vpc.ipv6Cidr
				}));
				const {vpcId, extensionVpcId, vpcCidr, extensionVpcCidr} = this.rowInfo || {}
                if(this.networkName==='eth0') {
                    this.netInfo.vpcList = this.netInfo.vpcList?.length && this.netInfo.vpcList?.filter(item => item.vpcId !== vpcId && item.vpcId !== extensionVpcId  && item.cidr !== extensionVpcCidr)
                } else if(this.networkName==='eth1'){
                    this.netInfo.vpcList = this.netInfo.vpcList?.length && this.netInfo.vpcList?.filter(item => item.vpcId !== vpcId && item.vpcId !== extensionVpcId && item.cidr !== vpcCidr)
                }
			}
			return this.netInfo.vpcList || [];
		},
        subnetShowList() {
            if(!this.subnetNotChange) {
				if (this.netInfo.subnetList.length) {
					this.netInfo.subnetList = this.netInfo.subnetList.map(subnet => ({
						subnetId: subnet.subnetId,
						name: subnet.name,
						showName: `${subnet.name}(${subnet.subnetId})`,
						cidr: subnet.cidr,
						ipv6Cidr: subnet.ipv6Cidr,
						primaryCidr: subnet.cidr,
						region: subnet.region
					}));
				}
			}else {
				if (this.netInfo.subnetLists.length) {
					this.netInfo.subnetList = this.netInfo.subnetLists.map(subnet => ({
						subnetId: subnet.subnetId,
						name: subnet.name,
						showName: `${subnet.name}(${subnet.subnetId})`,
						cidr: subnet.cidr,
						ipv6Cidr: subnet.ipv6Cidr,
						primaryCidr: subnet.cidr,
						region: subnet.region
					}));
				}
			}
            this.netInfo.subnetList = this.netInfo.subnetList?.length && this.netInfo.subnetList?.filter(item=>item.subnetId !=this.rowInfo.extensionSubnetId && item.subnetId !=this.rowInfo.subnetId)
			// if (this.netInfo.subnetLists.length) {
			// 	this.netInfo.subnetList = this.netInfo.subnetLists.map(subnet => ({
			// 		subnetId: subnet.subnetId,
			// 		name: subnet.name,
			// 		showName: `${subnet.name}(${subnet.subnetId})`,
			// 		cidr: subnet.cidr,
			// 		ipv6Cidr: subnet.ipv6Cidr,
			// 		primaryCidr: subnet.cidr,
			// 		region: subnet.region
			// 	}));
			// }
			return this.netInfo.subnetList || [];
		},
		renetworkDisabled() {
			if(Object.keys(this.rowInfo).length){
				let disabled = this.rowInfo.checkModifyVpc?.ifSlb|| this.rowInfo.checkModifyVpc?.ifAliasIp|| this.rowInfo.checkModifyVpc?.ifIPv6|| this.rowInfo.checkModifyVpc?.ifEip;
				return disabled;
			}
			else {
				return true
			}

		},
		renetworkDisabledTip() {
			if(Object.keys(this.rowInfo).length){
				if(this.rowInfo.checkModifyVpc?.ifSlb) {
					return this.$t('privateNetInstance.operations.alreadyAddLb');
				}
				if(this.rowInfo.checkModifyVpc?.ifIPv6) {
					return this.$t('privateNetInstance.operations.alreadyHaveIPv6');
				}
				if(this.rowInfo.checkModifyVpc?.ifEip) {
					return this.$t('privateNetInstance.operations.alreadyBindEip');
				}
				if(this.rowInfo.checkModifyVpc?.ifAliasIp) {
					return this.$t('privateNetInstance.operations.alreadyBindOtherIp');
				}
			}


		}
	},
	watch: {
		selectedPartitionMode(newValue, oldVlue) {
			if (newValue === 'default') {
				this.resetDiskCapacity('system');
			}
		},
		selectedDataDiskPartitionMode(newValue, oldVlue) {
			if (newValue === 'default') {
				this.resetDiskCapacity('data');
			}
		},
		selectedImageType (newValue, oldVlue) {
			this.form.osTypeId = '';
			this.systemDataPartitions = [];
			this.dataDiskPartitions = [];
			this.defaultSystemDataPartitions = '';
			this.defaultDataDiskPartitions = '';
			this.getAvailableOS(this.rowInfo);
		},
		networkName() {
            this.getVpcCount('netInfo');
			if(this.vpcNotChange && !this.subnetNotChange) {
				this.existingVpcFixed();
			} else if (this.vpcNotChange && this.subnetNotChange) {
				this.getSubnetByVpc();
				this.existingVpcFixed();
				this.existingSubnetFixed();
			}else if(!this.vpcNotChange && !this.subnetNotChange) {
				this.netInfo = {
					vpcCount: 0,
					subnetCount: 0,
					vpcList: [],
					vpcLists: [],
					subnetList: [],
					subnetLists:[],
					selectVpcId: '',
					selectVpcName: '',
					selectVpcCidr: '',
					selectVpcIpv6Cidr: '',
					selectSubnetId: '',
					selectSubnetName: '',
					selectSubnetCidr: '--',
					selectSubnetIpv6Cidr: '--',
					isAuto: 1,
					internetIp: '',
					ipOperations: [
						{
							value: 1,
							label: this.$t('privateNetInstance.autoIPv4')
						},
						{
							value: 0,
							label: this.$t('privateNetInstance.handwriteIPv4')
						}
					],
				};
			}


        },
		"netInfo.internetIp"() {
			let formValid = true;
			this.$refs.networkInfo.validate((valid) => {
				formValid = valid;
			});
			if (!formValid&&this.netInfo.isAuto !== 1) {
				this.internetIpVaild = true
			}else{
				this.internetIpVaild = false
			}
		},
	},
	created() {
        //this.rowInfo = JSON.parse(decodeURIComponent(this.$route.params.jsonStr));
		this.region = this.$route.query.region;
		this.az = this.$route.query.az;
		this.instanceId = this.$route.query.instanceId;
		this.deviceType = this.$route.query.deviceType;
		this.clickToDetail = this.$route.query.clickToDetail;
		this.getAzData();
		this.getInstanceInfo();
		// this.getVpcCount('netInfo');


	},
	mounted() {
		//this.networkName = this.networkNameTag;
		this.init();

	},
	beforeUpdate() {
		this.existingVpcFixed();
		this.existingSubnetFixed();
	},
	methods: {
		/**
		 * 获得组件传出的值
		 * @param loginType
		 * @param password
		 */
		getPassword(loginType, password, selectKey, sosKey) {
			this.form.loginType = loginType;
			this.form.password = password;
			this.form.selectKey = selectKey;
            this.form.sosKey = sosKey;
		},
		/**
		 * 根据raid类型和机型返回展示名称
		 * @param raidType
		 * @param deviceType
		 * @return {*}
		 */
		getDataDiskCardTitle(raidType, deviceType) {
			if (raidType === 'RAID51H') {
				if (deviceType === 'cps.c.perf3') {
					return 'RAID 5+1 hotspare';
				} if (deviceType === 'cps.s.perf1') {
					return 'RAID 5+1 hotspare+NO RAID';
				}
			} else {
				return raidType;
			}
		},
		/**
		 * 获得通过校验的输入内容
		 * 且内容已经base64过了
		 */
		getCustomData(value) {
			this.form.userData = value;
		},
		systemChange() {
			this.form.osTypeId = '';
			this.systemDataPartitions = [];
			this.dataDiskPartitions = [];
			this.defaultSystemDataPartitions = '';
			this.defaultDataDiskPartitions = '';
		},
		// 数据盘选项操作
		getSelectType(item) {
			this.selectedDataRaid = item;
			this.resetDataPartitionModes(item);
			let dataDiskCapacity = item.availableValue;
			this.calculateDiskCapacity('data',dataDiskCapacity);
			this.resetDiskCapacity('data');
			this.form.dataRaidTypeId = item.raidTypeId;
			this.form.dataRaidType = item.raidType;
		},
		handleClose() {
      this.sureLoading = false;
			this.$router.push({
				path: '/instance/vpc/list',
				query: {
					region: this.rowInfo.region
				}
			});
		},
		jumpToDetail() {
			this.$router.push({
		        path: '/instance/vpc/detail/performance',
		        query: {
					id: this.rowInfo.instanceId,
					region: this.rowInfo.region,
					az: this.rowInfo.az,
					tabName:'sourceInfo',
					cpsType:'cps-vpc'
		        }
	      	});
		},
		cancelReInstall() {
			if (this.clickToDetail) {
				this.jumpToDetail();
			} else {
				this.handleClose();
			}

		},
		init() {
			$('.mainCon').scroll();
		},
		locateToErrorElement(id) {
			$('.mainCon').scrollTop($('.mainCon').scrollTop() + $(`#${id}`).offset().top
				- $('.mainCon').offset().top - 30);
		},
		/**
		 * 重装系统时点击确定
		 * 增加了高级设置form
		 * 两个form校验均通过后打开重装系统确认
		 */
		sureReInstall(formName) {
			let systemDiskPartitions = this.systemDataPartitions.filter(item => !item.isNoPartition).map(item => {
					return {
						"size": item.size,
	                    "format": item.format,
	                    "point": item.point
					}
			});
			if (this.selectedPartitionMode === 'default') {
				systemDiskPartitions = [];
			}
			let dataDiskPartitions = this.dataDiskPartitions.filter(item => !item.isNoPartition).map(item => {
					return {
						"size": item.size,
	                    "format": item.format,
	                    "point": item.point
					}
			});
			if (this.selectedDataDiskPartitionMode === 'default') {
				dataDiskPartitions = [];
			}
			if(!this.form.osTypeId) {
				this.locateToErrorElement('osTypeId');
				return false;
			}
			// 校验系统盘及数据盘自定义分区模式下是否保存
			if(this.$refs.systemPartition && this.$refs.systemPartition.isRowNotSaved) {
				this.locateToErrorElement('systemPartition');
				return false;
			}
			if(this.$refs.dataPartition && this.$refs.dataPartition.isRowNotSaved) {
				return false;
			}
			this.$refs[formName].validate((valid) => {
				let pass = true;
				if (valid) {
					this.$refs.loginMethods.$refs.loginForm.validate((threeValid) => {
						pass = threeValid;
					});
					if (!pass) {
						this.locateToErrorElement('login');
						return false;
					}
					if (typeof this.$refs.advancedCustomData !== 'undefined') {
						this.$refs.advancedCustomData.$refs.advanced.validate((twoValid) => {
							pass = twoValid;
						});
					}
					this.form.systemDiskPartitions = systemDiskPartitions;
					this.form.dataDiskPartitions = dataDiskPartitions;
					this.openOperationProtect(OperationConstant.REINSTALL);

				} else {
					return false;
				}
			});
		},
		/**
		 * 重装系统时点击确定
		 * 增加了操作保护
		 * 增加的参数的逻辑变化
		 */
        systemReinstallTwiceConfirm(headers) {
          this.sureLoading = true;
			const params = {
				instanceId: this.rowInfo.instanceId,
				region: this.rowInfo.region,
				az: this.rowInfo.az,
				imageType: 'standard',
				keepData: this.form.checked ? 'no' : 'yes',
				clientToken: Normal.getClientToken(),
				osTypeId: this.form.osTypeId,
				sysRaidTypeId: this.rowInfo.sysRaidTypeId,
				dataRaidTypeId: this.form.checked
					? this.form.dataRaidTypeId
					: this.rowInfo.dataRaidTypeId,
				userData: this.form.advancedSetting
					? this.form.userData
					: undefined,
				loginType: this.form.loginType, // 登录方式
				systemDiskPartitions: this.form.systemDiskPartitions, //系统盘分区
				dataDiskPartitions: this.form.dataDiskPartitions //数据盘分区
			};
			if (this.form.hostname !== '') {
				params.hostname = this.form.hostname;
			}
			if (this.form.loginType === 'keyPair') {
				params.keyPairId = this.form.selectKey;
                params.keypairIdSos = this.form.sosKey;
			} else if (this.form.loginType === 'pwd') {
				params.password = this.form.password;
				if(this.form.selectKey !== '') {
					params.keypairIdSos = this.form.selectKey;
				}
			}
			if(this.changeNetValue){
				params.interfaceName = this.networkName;
				params.targetVpcIden = this.netInfo.selectVpcId;
                params.targetSubnetIden = this.netInfo.selectSubnetId;
            }
			if (!this.netInfo.isAuto) {
				params.targetRip = this.netInfo.internetIp;
			}
			let dealHeaders = Object.assign({},headers,{'Content-Type': 'application/json'});
			Ajax.post('/api/cps/reinstallInstance', params, {
				headers: dealHeaders
			}).then((res) => {
				if (res.data) {
                    this.handleClose();
                }
			}).catch(async (err) => {
        this.sureLoading = false;
					const { response } = err.data;
                    this.buttonOnes = false;
					try {
						const json = await response.json();
                        // 拦截IPv4校验重复的枚举转译
                        let messageTip = '';
                        if (json.errmsg === 'RIP_DUPLICATE') {
                            messageTip = 'IPv4 地址已占用，请重新输入';
                        }
                        this.$message.error(messageTip || json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
			}).finally(() => {
        this.sureLoading = false;
				// this.handleClose();
			});
		},
		/**
		 * 重装系统时点击确定
		 * 增加了更换网络功能
		 * 根据参数确定更换vpc，子网和目标内网
		 */
		sureReNetwork() {
			this.buttonOnes = true
			if(!this.vpcNotChange && !this.subnetNotChange) {
				this.changeVPC()
			}
        },
		getSelectOsId(osId) {
			let osTypes = this.form.osTypes[this.form.operate];
			let osName = osTypes.filter((item) => item.osTypeId === osId).reduce((init, current) => {return init + current.osName},'')
			let spaceReg = /\s+/g;
			let selectOsName = osName.split(spaceReg).splice(0,2).join(' ');
			// CentOS 6.6自定义分区文件系统特殊处理标识
			if (selectOsName === 'CentOS 6.6') {
				this.isCentOS66 = true;
			} else {
				this.isCentOS66 = false;
			}
			if (!osId) {
				return
			}
			let customPartitionSupport = this.deviceCustomPartitionSupport;
			let isQcow2 = osTypes.filter(item => item.osTypeId === osId).every(item => item.format === 'qcow2');
			this.resetPartitionModes(customPartitionSupport && !isQcow2);
			this.resetDataPartitionModes(this.selectedDataRaid);
			this.getOSPartitions();
		},

		getOSPartitions() {
			if (!this.rowInfo.region || !this.rowInfo.deviceType || !this.form.osTypeId) {
				return
			}

			const param = {
		        region: this.rowInfo.region,
		        deviceType: this.rowInfo.deviceType,
		        imageId: this.form.osTypeId
		    };
		    Ajax.get('/api/cps/getOSPartitions', param)
		    .then((res) => {
				let partitions = res.data.partitions;
				this.handleSystemPartitions(partitions);
				this.handleDataPartitions(partitions);
		    }).catch(async (err)=>{
		    	const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		    });
		},

		dealRemainSystemDataPartitions(diskSize,diskPartitions) {
			return diskSize - diskPartitions.filter(item => item.size !== 999999999).reduce((init,current) => {
				return init + current.size
			},0);
		},

		dealDefaultPartitions(partitions) {
			let defaultPartitions = deepCopy(partitions);
				defaultPartitions.map((item) => {
					item.size = item.isRemainDataPartition ? this.$t('retailInstance.text.allRemainingSpace') : `${item.size}GiB`;
				});
			return defaultPartitions.reduce((init,current) =>{
				return `${init}<strong class="ml5 mr5">${current.point}:</strong><span>${current.size},${current.format};</span>`
			},'')
		},

		handlePartitions(remainPartitions, diskPartitions, type) {
			let hasRemainDataPartition = false;
			let systemDataPartitions = diskPartitions.map(item=>{
				item.isEditing = false;
				if (item.size === 999999999) {
					item.size = remainPartitions;
					item.isRemainDataPartition = true;
					hasRemainDataPartition = true;
				}
				item.size = item.size / 1024;
				return item
			});

			if (type === 'systemDisk') {
				this.defaultSystemDataPartitions = this.dealDefaultPartitions(systemDataPartitions);
			} else if (type === 'dataDisk'){
				this.defaultDataDiskPartitions = this.dealDefaultPartitions(systemDataPartitions);
			}
			systemDataPartitions.push({
				point: this.$t('retailInstance.text.emptyPartition'),
				isEditing: false,
				size: hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024,10) ,
				format: this.isCentOS66 ? 'ext3' : 'xfs',
				isNoPartition: true
			});
			systemDataPartitions.map(item => {
				if (item.point === '/') {
					item.minSize = 5;
				} else if (item.point === '/boot') {
					item.minSize = 1;
				} else {
					item.minSize = 0;
				}
				item.maxSize = item.size + (hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024,10))
				return item
			});
			return systemDataPartitions
		},

		handleSystemPartitions(partitions) {
			let remainSystemDataPartitions =  this.dealRemainSystemDataPartitions(this.systemDiskSize*1024, partitions.systemDiskPartitions);
			this.systemDataPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.systemDiskPartitions, 'systemDisk');
		},

		handleDataPartitions(partitions) {
			let remainSystemDataPartitions =  this.dealRemainSystemDataPartitions(this.dataDiskSize*1024, partitions.dataDiskPartitions);
			this.dataDiskPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.dataDiskPartitions, 'dataDisk');
		},
		resetDiskCapacity(type) {
			if (!this.rowInfo.region || !this.rowInfo.deviceType || !this.form.osTypeId) {
				return
			}
			const param = {
		        region: this.rowInfo.region,
		        deviceType: this.rowInfo.deviceType,
		        imageId: this.form.osTypeId
		    };
		    Ajax.get('/api/cps/getOSPartitions', param)
		    .then((res) => {
				let partitions = res.data.partitions;
				if (type === 'system') {
					this.handleSystemPartitions(partitions);
				} else if(type === 'data') {
					this.handleDataPartitions(partitions);
				}
		    }).catch(async (err)=>{
		    	const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		    });
		},
		calculateDiskCapacity(type, capacity) {
			let diskCapacity = Math.floor(capacity * 0.93);
			if (type === 'system') {
				this.sysDiskCapacity =  diskCapacity + 'GiB';
				this.systemDiskSize = diskCapacity;
			} else if (type === 'data') {
				this.dataDiskCapacity = diskCapacity + 'GiB';
				this.dataDiskSize = diskCapacity;
			}
		},
		getAvailableOS(instance) {
			const params = {
				region: this.region,
				deviceType: this.deviceType,
			};
			const osTypes = []; const operates = {}; const imageTypes = [];
			Ajax.get('/api/cps/getAvailableOS', params)
				.then((res) => {
					const data = res.data;
					let dataList = [];
					for (const i in data.oss) {
						const image = {};
						image.source = data.oss[i].source;
						image.sourceName = data.oss[i].sourceName;
						imageTypes.push(image)
					}
					var obj = {};
					this.imageTypes = imageTypes.reduce(function(item, next) {
						obj[next.source] ? '' : obj[next.source] = true && item.push(next);
						return item;
					}, []);
                    // 按照order顺序对this.imageTypes进行排序，防止每次“镜像类型”位置变动
                    const order = ['common', 'customize', 'user_defined_create']
                    this.imageTypes = this.imageTypes?.sort((a, b) => {
                        return order.indexOf(a?.source) - order.indexOf(b?.source);
                    });
					dataList = data.oss.filter(item=>item.source === this.imageTypes[this.selectedImageType].source);
					dataList.forEach((os) => {
						if (!operates[os.osType]) {
							osTypes.push(os.osType);
							operates[os.osType] = [];
						}
						operates[os.osType].push(os);
					});
				})
				.catch()
				.finally(() => {
					this.form.osTypes = operates;
					this.form.oss = osTypes;
					this.form.operate = osTypes[0];
				});
		},
		/**
		 * 获取可用raid类型
		 * 同时将from.dataRaidTypeId初始化为rowInfoRaidTypeId
		 * @param info
		 */
		getAvailableRaids(info) {
			const params = {
				region: info.region,
				deviceType: info.deviceType
			};
			Ajax.get('/api/cps/getAvailableRaids', params)
			.then((res) => {
				//  处理系统盘分区总容量及数据盘总容量
				let sysDiskCapacity = res.data.raids.filter( item => item.volumeType === 'system')[0].availableValue;
				let systemPartitionCount = res.data.raids.filter( item => item.volumeType === 'system')[0].systemPartitionCount;
				sysDiskCapacity = sysDiskCapacity / systemPartitionCount;
				this.calculateDiskCapacity('system',sysDiskCapacity);
				let dataDiskCapacity;
				const tempDataRaids = [];
				res.data.raids.forEach((raid) => {
					if (raid.volumeType === 'data') {
						if (raid.raidType === 'NORAID') {
							tempDataRaids.unshift(raid);
						} else {
							tempDataRaids.push(raid);
						}
					}
				});
				this.form.dataDisks = tempDataRaids;
				this.form.hasRowInfoDataRaidTypeId = tempDataRaids.some(item => item.raidTypeId === this.rowInfo.dataRaidTypeId);
				if (this.form.hasRowInfoDataRaidTypeId) {
					this.form.dataRaidTypeId = this.rowInfo.dataRaidTypeId;
					this.form.dataRaidType = this.rowInfo.dataRaidType;
					//  兼容处理noraid
					this.rowInfo.raidType = this.rowInfo.dataRaidType;
					this.selectedDataRaid = this.rowInfo;
					this.resetDataPartitionModes(this.rowInfo);
					dataDiskCapacity = tempDataRaids.filter(item => item.raidTypeId === this.form.dataRaidTypeId)[0].availableValue
				} else {
					this.form.dataRaidTypeId = tempDataRaids[0].raidTypeId;
					this.form.dataRaidType = tempDataRaids[0].raidType;
					this.selectedDataRaid = tempDataRaids[0];
					//  兼容处理noraid
					this.resetDataPartitionModes(tempDataRaids[0]);
					dataDiskCapacity = tempDataRaids[0].availableValue;
				}
				this.calculateDiskCapacity('data',dataDiskCapacity);
			});
		},

		// noraid数据盘分区模式特殊处理
		resetDataPartitionModes(item) {
			// 机型不支持自定义分区就不需要再对数据盘单独处理
			if (!this.deviceCustomPartitionSupport) {
				return
			}
			if (item.raidType === 'NORAID') {
				this.dataDiskPartitionModes = [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
				];
			} else {
				this.dataDiskPartitionModes = [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
					{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
				];
			}
			this.selectedDataDiskPartitionMode = 'default';
		},

		// 是否支持自定义分区
		resetPartitionModes(customPartitionSupport) {
			if (!customPartitionSupport) {
				this.systemDiskPartitionModes = [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'}
				];
				this.dataDiskPartitionModes = [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'}
				];
			} else {
				this.systemDiskPartitionModes = [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
					{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
				],
				this.dataDiskPartitionModes = [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
					{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
				];
			}
			this.selectedPartitionMode = 'default';
			this.selectedDataDiskPartitionMode = 'default';
		},
		getInstanceInfo() {
			this.tableData = [];
			this.form.showData = [];
			const params = {
				region: this.region,
				instanceId: this.instanceId,
				az: this.az
			};
			Ajax.get('/api/cps/getInstanceInfo', params)
			.then((res) => {
				if (res.data) {
					this.rowInfo = res.data.instance;
                    this.getVpcCount('netInfo');
					const detail = res.data.instance;
					const info = {
						region: this.rowInfo.region,
                        instanceId: this.rowInfo.instanceId,
                        osName: this.rowInfo.osName,
						deviceType: this.rowInfo.deviceType,
						name: detail.name,
						system: detail.systemDiskDesc,
						chargeType: this.transformCharge(detail.charge.chargeMode),
						expire: detail.charge.chargeExpiredTime,
						dataDiskDesc: detail.dataDiskDesc
					};
					const mes = {
						instanceId:this.rowInfo.instanceId,
						instanceName:this.rowInfo.name,
						az:this.transformAz(this.rowInfo.az),
						privateNetwork:this.rowInfo.vpcName,
						subnet:this.rowInfo.subnetName,
						intranetIp: [ this.rowInfo.privateIp,this.rowInfo.ipv6Address],
						extensionPrivateNetwork:this.rowInfo.extensionVpcName,
						extensionSubnet:this.rowInfo.extensionSubnetName,
						extensionIntranetIp: [ this.rowInfo.extensionPrivateIp,this.rowInfo.extensionIpv6Address],

					};
					let customPartitionSupport = detail.cpsConfiguration.deviceType.customPartitionSupport
					this.deviceCustomPartitionSupport = CustomPartitionSupportConstant[customPartitionSupport];
					this.resetPartitionModes(this.deviceCustomPartitionSupport);
					this.chargeModeType = detail.charge.chargeMode;
					this.getAvailableRaids(info);
					this.deviceType = detail.deviceType;
					this.tableData.push(info);
					this.tableNetData.push(mes);
                    this.form.hostname = detail.hostname;
					this.form.showData.push({
						raidType: detail.dataRaidType,
						description: detail.dataRaidType,
						volumeDetail: detail.dataDiskDesc
					});
				}
			});
			this.getAvailableOS(this.rowInfo);
			//this.getAvailableRaids(this.rowInfo);
		},
		//获取可用区中文
		getAzData() {
			const params = {
				region: this.region,
				networkType: 'vpc'
			};
			Ajax.get('/api/filter/listInstances', params).then((res) => {
				if (res.errno === 10000 && res.data) {
					const filtersArray = [];
					const filtersObj = res.data.azs;
					Object.keys(filtersObj).forEach((item) => {
						const temp = {};
						temp.value = item;
						temp.text = filtersObj[item];
						filtersArray.push(temp);
					});
					this.azs = filtersArray;
				}
	        }).finally(() => {
	        });
		},
		//转换可用区中文
		transformAz(vaule) {
	      	let realAz;
	      	this.azs.forEach((az) => {
		        if (az.value === vaule) {
		        	realAz = az.text;
		        }
	      	});
	      	return realAz;
	    },
		//更换当前vpc网络
		changeVPC() {
			const params = {
                region: this.rowInfo.region,
                instanceId: this.rowInfo.instanceId,
				interfaceName : this.networkName,
				targetVpcIden: this.netInfo.selectVpcId,
                targetSubnetIden: this.netInfo.selectSubnetId,
            };
			if (!this.netInfo.isAuto) {
				params.targetRip = this.netInfo.internetIp;
			}
            Ajax.post('/api/cps/modifyInstanceVPC', params)
            .then((res) => {
               this.$message.success(this.$t('privateNetInstance.operateSuccess'));

            })
            .catch(async (err) => {
                const { response } = err.data;
                this.buttonOnes = false;
                try {
                    const json = await response.json();
                    // 拦截IPv4校验重复的枚举转译
                    let messageTip = '';
                    if (json.errmsg === 'RIP_DUPLICATE') {
                        messageTip = 'IPv4 地址已占用，请重新输入';
                    }
                    this.$message.error(messageTip || json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
            });
		},
		// 获取选中当前vpc
		vpcChange(id,tag) {
			if (tag === 'netInfo') {
				this.selectedSubnetDetail = {};
				this.$refs.networkInfo.clearValidate(['selectSubnetId']);
			}
			this[tag].selectSubnetId = '';
			this[tag].selectSubnetName = '';
			this[tag].selectSubnetCidr = '--';
			this[tag].selectSubnetIpv6Cidr = '--';
            this[tag].subnetList = [];
            this[tag].subnetLists = []
            this[tag].subnetCount = 0;
			this.resetIpv4(tag);
			if (id) {
				this.getSubnetByVpc(id);
				this.getSelectVpcName(id,tag);
				this.getSelectVpcCidr(id,tag);
			}
		},
        resetIpv4(tag) {
			this[tag].isAuto = 1;
			this[tag].internetIp = '';
		},
        // 获取当前vpc下子网
		getSubnetByVpc(id) {
			if(this.networkName==='eth0') {
				this.realVpcId = this.vpcNotChange ? this.rowInfo.vpcId : id
			} else if(this.networkName==='eth1') {
				this.realVpcId = this.vpcNotChange ? this.rowInfo.extensionVpcId : id
			};
			const params = {
				region: this.rowInfo.region,
				vpcId: this.realVpcId,
				pageSize: 100
			};
			Ajax.get('/api/cps/listSubnets', params)
			.then((res) => {
                const {subnets} = res.data || {};
                if (subnets && subnets?.length) {
                    this.netInfo.subnetList = subnets
                    this.netInfo.subnetLists = subnets
                    this.netInfo.subnetCount = subnets.length;
                }
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
		},
        // 获取选中vpc名称
		getSelectVpcName(vpcId,tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].selectVpcName = vpc.name;
				}
			});
		},
        // 获取选中vpc cidr及ipv6 cidr
		getSelectVpcCidr(vpcId,tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].selectVpcCidr = vpc.cidr;
					this[tag].selectVpcIpv6Cidr = vpc.ipv6Cidr;
				}
			});
		},
        /*
		*  当前页面可以跳转其它页面创建vpc
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeVpc(isVisible,tag) {
			if (isVisible) {
				this.getVpcCount(tag);
			}
		},
        // 获取当前区域下vpc
		getVpcCount(tag) {
            const {vpcCidr, extensionVpcCidr} = this.rowInfo || {};
			const params = {
				pageNumber: 1,
				pageSize: 100,
				region: this.region,
			};
            if (this.networkName==='eth0') {
                params.cidrToFilter = extensionVpcCidr;
            } else if (this.networkName==='eth1') {
                params.cidrToFilter = vpcCidr;
            }
			Ajax.get('/api/cps/listVpcs', params)
			.then((res) => {
				if (res.data.vpcs) {
					if (tag === 'netInfo') {
						this.netInfo.vpcList = res.data.vpcs;
						this.netInfo.vpcLists = res.data.vpcs
						this.netInfo.vpcCount = this.netInfo.vpcList.length;
					} else {
						this.netInfo.vpcCount  = res.data.vpcs.length;
						this.netInfo.vpcLists = res.data.vpcs
						this.netInfo.vpcList = res.data.vpcs;
					}
				}
			})
			.catch(async (err)=>{
		    	const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		    });
		},
		//下拉框默认带出当前网口的VPC信息，置灰不可修改
		existingVpcFixed() {
			if(this.vpcNotChange) {
				if(this.networkName==='eth0') {
					this.netInfo.selectVpcId = this.rowInfo.vpcId
				}else if(this.networkName==='eth1') {
					this.netInfo.selectVpcId = this.rowInfo.extensionVpcId
				};
				this.netInfo.vpcList.forEach((vpc) => {
					if (vpc.vpcId === this.netInfo.selectVpcId) {
						this.netInfo.selectVpcCidr = vpc.cidr;
						this.netInfo.selectVpcIpv6Cidr = vpc.ipv6Cidr;
					}
				});
			}
		},
		//下拉框默认带出当前网口的子网信息，置灰不可修改
		existingSubnetFixed() {
			if(this.subnetNotChange) {
				if(this.networkName==='eth0') {
					this.netInfo.selectSubnetId = this.rowInfo.subnetId
				}else if(this.networkName==='eth1') {
					this.netInfo.selectSubnetId = this.rowInfo.extensionSubnetId
				};
				this.netInfo.subnetList.forEach((subnet) => {
					if (subnet.subnetId === this.netInfo.selectSubnetId) {
						this.selectedSubnetDetail = subnet;
						this.netInfo.selectSubnetName = subnet.name;
						this.netInfo.selectSubnetCidr = subnet.cidr;
						this.netInfo.selectSubnetIpv6Cidr = subnet.ipv6Cidr;
					}
				})

			}
		},
        // 获取选取子网名称
		subnetChange(subnetId,tag) {
			this[tag].subnetList.forEach((subnet) => {
				if (subnet.subnetId === subnetId) {
					if (tag === 'netInfo') {
						this.selectedSubnetDetail = subnet;
					}
					this[tag].selectSubnetName = subnet.name;
					this[tag].selectSubnetCidr = subnet.cidr;
					this[tag].selectSubnetIpv6Cidr = subnet.ipv6Cidr;
					this.resetIpv4(tag)
				}
			})
		},
        /*
		*  当前页面可以跳转其它页面创建subnet
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeSubnet(isVisible,tag) {
			if (!isVisible) {
				return
			}
			let vpcId = this[tag].selectVpcId
			this.getSubnetByVpc(vpcId);
		},
        trimValue(type) {
			if (type === 'internetIp') {
				this.netInfo.internetIp  = this.netInfo.internetIp.replace(/^\s+|\s+$/g,'');
			}
		},
        clearInputIp(tag) {
			this[tag].internetIp = '';
		},
		transformCharge(payMethod) {
	      	switch (payMethod) {
		        case 'prepaid_by_duration':
		          return this.$t('privateNetInstance.monthAndYear');
		        case 'postpaid_by_duration':
		          return this.$t('create.text.byConfigurations');
		        default:
		          return '';
	      	}
	    },
	}
};
</script>

<style lang="scss" scoped>
    .jc-form {
        width: 90% !important;
    }
	.re-system{
        .resystem-header {
            margin-left: 20px;
			margin-right: 20px;
            background-color: #ffffff !important;
            border-bottom: 1px solid #d9e1e9;
        }
        .ml40{
            overflow:hidden;
            margin-left: 40px;
			margin-right: 40px;
        }
		.basic-resys-login {
			.el-select {
				width: 320px;
			}
		}

		.title-position {
			margin-bottom: 20px;
			margin-top: 20px;
            font-size: 14px;
		}

		.el-form-item.is-hint {
			margin-bottom: 24px;
		}

		.el-alert--error {
			background-color: #fff2f4;
			border-color: #e15a5f;
			color: #e15a5f;
		}

		.form-position {
			margin-top: 20px;

			.el-select {
				width: 320px !important;
			}

			.el-input {
				width: 320px !important;
			}
		}


		.c333 {
			color: #333;
		}

        .dialog-resystem-footer {
            margin:50px 100px 50px 0;
            float: right;
        }


	}
</style>
<style lang="scss">
	.re-system{
		.defaultPartition {
			strong {
				color: #212121;
			}
		}
		.el-input--small .el-input__inner {
            height: 32px;
        }
		.network {
			.el-radio-button__inner {
				padding:0 10px 0 10px;
			}
		}
		.table-size {
			width: 95%;
		}

		.net-table-size {
			width: 95%;
			margin: 0 0 24px 18px;
		}
		.mb0 {
			margin-bottom: 0;
		}
		.ip-input {
			display: flex;
			.inner-ip {
				margin-left: 20px;
				width: 300px;
			}
			.ipv6 {
				margin-left: 10px;
				width: 100px;
			}

			.el-form-item__error {
				padding-top: 2px;
				margin-left: 20px;
			}

			.el-form-item-help {
				margin-left: 20px;
			}
		}
		a {
			color: #2C68FF;
		}

		.network-name {
			.el-radio-button__inner {
				padding: 10px;
			}
		}
		.el-form-item__content {
			input {
				vertical-align: middle;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/reinstallSystem/reinstallSystem.vue